<template>
    <div>
        <el-page-header @back="close" :content="(form.id > 0 ? '编辑' : '新增') + '短信通道'"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="名称" prop="name" :error="errors.name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="组" prop="category" :error="errors.category">
                        <el-select v-model="form.category" :disabled="form.id > 0" @change="changeCategory">
                            <el-option label="大汉三通" value="dh3t"></el-option>
                            <el-option label="助通云" value="zthy"></el-option>
                            <el-option label="高兆" value="shgm"></el-option>
                            <el-option label="创蓝" value="chlan"></el-option>
                            <el-option label="云旭" value="yunxu"></el-option>
                            <el-option label="博士通" value="bst"></el-option>
                            <el-option label="新积域(营销)" value="xjym"></el-option>
                            <el-option label="新积域(行业)" value="xjyb"></el-option>
                            <el-option label="新积域(视频)" value="xjyv"></el-option>
                            <el-option label="梓朗" value="zilang"></el-option>
                            <el-option label="嵘垠" value="ryv"></el-option>
                            <el-option label="嵘垠(短信)" value="rys"></el-option>
                            <el-option label="五爻" value="51v"></el-option>
                            <el-option label="创蓝(视频)" value="clv"></el-option>
                            <el-option label="道信" value="future"></el-option>
                            <el-option label="道信（备）" value="future2"></el-option>
                            <el-option label="道信（国际）" value="ifuture"></el-option>
                            <el-option label="道信（国际语音）" value="futureiy"></el-option>
                            <el-option label="联动优势" value="ldysv"></el-option>
                            <el-option label="创蓝彩视" value="clvm"></el-option>
                            <el-option label="地阳" value="diyang"></el-option>
                            <el-option label="梓朗（视频）" value="zlv"></el-option>
                            <el-option label="创瑞" value="chrui"></el-option>
                            <el-option label="创瑞（国际）" value="ichrui"></el-option>
                          <el-option label="旦米" value="danmi"></el-option>
                            <el-option label="地阳（语音+短信）" value="diyangn"></el-option>
                            <el-option label="地阳（国际语音）" value="dyiy"></el-option>
                          <el-option label="九十光年（国际）" value="ijsgn"></el-option>
                            <el-option label="测试专用" value="noop"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型" prop="type.value" :error="errors.type">
                        <RemoteSelect v-model="form.type.value" :url="'/dict/list/channel/type'"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="账号" prop="account" :error="errors.account">
                        <el-input v-model="form.account"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password" :error="errors.password">
                        <el-input v-model="form.password"></el-input>
                    </el-form-item>
                    <el-form-item :label="remarkLabel" prop="remark" :error="errors.remark">
                        <el-input v-model="form.remark"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status.value" :error="errors.status">
                        <RemoteSelect v-model="form.status.value" :url="'/dict/list/public/status'"></RemoteSelect>
                    </el-form-item>
                    <template v-if="form.id > 0">
                      <el-form-item>
                        报告推送地址：{{ getHost() }}/api/callback/{{ form.category }}/report<br/>
                        上行推送地址：{{ getHost() }}/api/callback/{{ form.code }}/reply<br/><br/>
                        彩信模板状态推送地址：{{ getHost() }}/api/mms/callback/template/{{ (form.category === "clv" || form.category === "clvm") ? "chlan" : form.category }}<br/>
                        视频短信模板状态推送地址：{{ getHost() }}/api/vms/callback/template/{{ (form.category === "clv" || form.category === "clvm") ? "chlan" : form.category }}<br/>
                      </el-form-item>
                    </template>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import RemoteSelect from '@/components/RemoteSelect'

    export default {
        components: {
            RemoteSelect
        },
        data() {
            return {
                form: {
                    id: this.$route.params.id,
                    name: "",
                    category: "",
                    account: "",
                    password: "",
                    type: {},
                    batchLimit: 1,
                    rateLimit: 1,
                    remark: "",
                    status: {},
                    code: ""
                },
                rules: {
                    name: [
                        {required: true, message: "请填写通道名称"}
                    ],
                    category: [
                        {required: true, message: "请选择通道组"},
                    ],
                    account: [
                        {required: true, message: "请填写通道账号"},
                    ],
                    password: [
                        {required: true, message: "请填写通道密码"},
                    ],
                    "type.value": [
                        {required: true, message: "请选择通道类型"}
                    ],
                    "status.value": [
                        {required: true, message: "请选择状态"}
                    ],
                },
                errors: {},
                remarkLabel: "备注"
            }
        },
        beforeMount() {
            if (this.form.id > 0) {
                this.$axios.get("/channel/get/" + this.form.id).then(result => {
                    this.$utils.merge(this.form, result);
                })
            }
        },
        methods: {
            submit() {
                let url = this.form.id > 0 ? "/channel/edit" : "/channel/save";
                this.$utils.submit(this.$refs.form, url, this.form, () => {
                    this.$router.go(-1);
                }, (data) => {
                    this.errors = data;
                });
            },
            close() {
                this.$router.go(-1);
            },
            changeCategory(category) {
                if (category) {
                    if (category === "bst") {
                        this.remarkLabel = "长号码";
                        return;
                    } else if (category.indexOf("xjy") > -1) {
                        this.remarkLabel = "签名ID";
                        return;
                    } else if (category === "chrui") {
                        this.remarkLabel = "扩展号";
                        return;
                    } else if (category === "danmi") {
                        this.remarkLabel = "业务账号";
                        this.form.account = "f411436353e43b197e7251ff536c859f";
                        this.form.password = "e960cd28a92aa07940136300d31d0ed4";
                        return;
                    } else if (category === "diyangn") {
                        this.remarkLabel = "应用代码";
                        return;
                    }
                }
                this.remarkLabel = "备注";
            },
            getHost() {
              return location.protocol + "//" + window.location.hostname;
            }
        }
    }
</script>